import React, { useEffect, useState } from 'react';
import { TextField } from '@esgian/esgianui';

type Props = {
  value: string;
  onChange: (value: string | null) => void;
  placeholder?: string;
  label?: string | undefined | null;
  type?: 'text' | 'password' | 'email'; // Extend as needed
  className?: string;
  helperText?: string | undefined;
  error?: boolean;
  handleFocusOff?: () => void | undefined;
};

const TextInput: React.FC<Props> = ({
  value = '',
  onChange,
  placeholder = '',
  label,
  type = 'text',
  className = '',
  handleFocusOff = undefined,
  error = false,
  helperText = undefined
}) => {
  const [tempValue, setTempValue] = useState(value);

  useEffect(() => {
    setTempValue(value);
  }, [value]);
  return (
    <TextField
      className={className}
      type={type}
      onBlur={() => {
        if (handleFocusOff) {
          handleFocusOff();
        }
        if (tempValue === value) return;
        onChange(tempValue);
      }}
      helperText={helperText}
      error={error}
      InputLabelProps={{ shrink: true }}
      inputProps={{
        sx: { textOverflow: 'ellipsis', pt: '12px', pb: '12px' }
      }}
      placeholder={placeholder}
      label={label}
      value={tempValue}
      onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => setTempValue(target.value)}
    />
  );
};

export default TextInput;
